// Vendored from the host app (conek-rails `app/frontend/shared/lib/action-cable/consumer.ts`)
// so the gem has no `shared/*` host-alias coupling. Types stripped, logic identical.

import { createConsumer } from "@rails/actioncable"

const CABLE_URL = "/cable"

const consumerCache = new Map()

/**
 * Returns a cached ActionCable consumer for the given space group.
 * Reuses the same WebSocket connection across all channels within a space group.
 */
export function getConsumer(spaceGroupId) {
  let consumer = consumerCache.get(spaceGroupId)
  if (!consumer) {
    // Security: space_group_id is read from server-side session, not passed in URL
    // This prevents tenant enumeration attacks
    consumer = createConsumer(CABLE_URL)
    consumerCache.set(spaceGroupId, consumer)
  }
  return consumer
}

/**
 * Removes a cached consumer for the given space group, forcing a new connection
 * on next getConsumer call.
 */
export function disconnectConsumer(spaceGroupId) {
  consumerCache.delete(spaceGroupId)
}
